import type { ApiClient } from "@/lib/api";
import type { PatchPluginRequest, Plugin } from "../types";

export const updatePlugin = async (options: {
  client: ApiClient;
  id: string;
  payload: PatchPluginRequest;
}): Promise<Plugin> => {
  const { client, id, payload } = options;
  const { data } = await client.patch<Plugin>(`/plugins/${id}`, payload);
  return data;
};
